/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ratio: NonNullable<unknown> }} Audio_Description_Export_Automix_Ratio_HelpInputs */



/**
* | output |
* | --- |
* | "Compression ratio (1:{ratio}) - higher means more ducking" |
*
* @param {Audio_Description_Export_Automix_Ratio_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_ratio_help = /** @type {((inputs: Audio_Description_Export_Automix_Ratio_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Ratio_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ratio de compression (1:${i?.ratio}) - plus élevé = plus d'atténuation`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Kompressionsverhältnis (1:${i?.ratio}) – ein höherer Wert bedeutet stärkeres Ducking`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rapporto di compressione (1:${i?.ratio}) - più alto significa più ducking`)
	if (locale === "ru") return /** @type {LocalizedString} */ ("Степень сжатия (1:PH0) — чем выше, тем больше демпфирование.")
	if (locale === "es") return /** @type {LocalizedString} */ (`Relación de compresión (1:${i?.ratio}): más alta significa más atenuación`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`压缩比 (1:${i?.ratio}) - 越高，意味着更多的下潜`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`圧縮比（1:${i?.ratio}） - 高いほどダッキングが多くなります`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`संपीड़न अनुपात (1:${i?.ratio}) - उच्च अनुपात का अर्थ है अधिक झुकना`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Taxa de compressão (1:${i?.ratio}) - quanto maior, mais abaixamento.`)
	return /** @type {LocalizedString} */ (`Compression ratio (1:${i?.ratio}) - higher means more ducking`)
});